import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import PlatformLogo from './PlatformLogo';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) { console.error('TELCOFAIR page error:', error, info); }
  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) this.setState({ hasError: false, error: null });
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <Box sx={{ minHeight: 330, display: 'grid', placeItems: 'center', p: 2 }}>
        <Box sx={{ width: 'min(520px,100%)', p: 3, textAlign: 'center', borderRadius: '20px', bgcolor: '#fff', border: '1px solid rgba(31,62,82,.08)', boxShadow: '0 12px 34px rgba(25,57,78,.08)' }}>
          <PlatformLogo width={88} height={56} radius={12} sx={{ mx: 'auto' }} />
          <Typography sx={{ mt: 1.3, fontWeight: 900, color: '#182235', fontSize: '1.05rem' }}>This page could not be loaded</Typography>
          <Typography sx={{ mt: .6, color: '#6D7C91', fontSize: '.72rem', lineHeight: 1.55 }}>The rest of the Super Admin workspace is still available. Retry this page without reloading the sidebar.</Typography>
          <Button startIcon={<Refresh />} onClick={() => this.setState({ hasError: false, error: null })} sx={{ mt: 1.5, borderRadius: '11px', textTransform: 'none', fontWeight: 800 }} variant="contained">Retry page</Button>
        </Box>
      </Box>
    );
  }
}
